// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatWorkflowSkillSummaryDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatWorkflowStatus } from "./chat-workflow-status.enum.gen";

export const ChatWorkflowSkillSummaryDtoGenShape = z.strictObject({
  id: z.string(),
  skillLineageId: z.string(),
  role: z.string(),
  name: z.string(),
  description: z.string().optional(),
  versionLabel: z.string().optional(),
  status: z.enum(ChatWorkflowStatus),
  temperature: z.number(),
  archived: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  publishedAt: z.string().optional(),
  createdBy: z.string().optional(),
  promptLength: z.number(),
});
